import { useEffect, useState } from 'react'
import {
  Alert,
  Card,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap'
import { SendCheckFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { Center } from '../../components/Center'
import { CustomButton } from '../../components/CustomButton'
import { CustomSpinner } from '../../components/CustomSpinner'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import { clearProps, isSomePropEmpty } from '../../utils/obj'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

export function AuthCodes() {
  const [data, setData] = useState({})
  const [accounts, setAccounts] = useState([])
  const [isAccountsLoading, setIsAccountsLoading] = useState(true)

  const [isSendCodesLoading, setIsSendCodesLoading] = useState(false)

  async function handleSendCodes() {
    try {
      setIsSendCodesLoading(true)

      await apinode.post(
        `/mercado-livre/auth-codes/${localStorage.idconta}`,
        data,
      )

      setData(clearProps(data))

      toast.success('Códigos inseridos com sucesso')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível inserir os códigos!')
    } finally {
      setIsSendCodesLoading(false)
    }
  }

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function loadAccounts() {
    try {
      setIsAccountsLoading(true)

      const response = await apinode.get(`/accounts/${localStorage.idconta}`)

      const accountsSorted = response.data.sort((a, b) => {
        if (a.apelido < b.apelido) {
          return -1
        }

        if (a.apelido > b.apelido) {
          return 1
        }

        return 0
      })

      for (const account of accountsSorted) {
        setData((prevState) => ({
          ...prevState,
          [account.apelido]: '',
        }))
      }

      setAccounts(accountsSorted)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as contas')
    } finally {
      setIsAccountsLoading(false)
    }
  }

  useEffect(() => {
    loadAccounts()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <h1>Códigos de Autorização Mercado Livre</h1>

        <Alert variant="warning">
          Essa ação sobrescreve os códigos anteriores.
        </Alert>

        {isAccountsLoading ? (
          <Center>
            <CustomSpinner />
          </Center>
        ) : (
          <Card>
            <Card.Body>
              <Row>
                {accounts.map((account, index) => (
                  <Col>
                    {account.outras_informacoes && (
                      <OverlayTrigger
                        overlay={
                          <Tooltip>{account.outras_informacoes}</Tooltip>
                        }
                      >
                        <Form.Label>{account.apelido}</Form.Label>
                      </OverlayTrigger>
                    )}

                    <Form.Control
                      name={account.apelido}
                      value={data[account.apelido]}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (
                          e.key === 'Enter' &&
                          index + 1 === accounts.length &&
                          !isSomePropEmpty(data)
                        ) {
                          handleSendCodes()
                        }
                      }}
                    />
                  </Col>
                ))}

                <Col>
                  <div
                    style={{
                      height: '100%',
                      display: 'flex',
                      alignItems: 'flex-end',
                    }}
                  >
                    <CustomButton
                      noMargin
                      title="Enviar"
                      isDisabled={isSomePropEmpty(data)}
                      isLoadingText="Enviando..."
                      isLoading={isSendCodesLoading}
                      onClick={handleSendCodes}
                    >
                      <SendCheckFill />
                    </CustomButton>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}
      </div>
    </>
  )
}
